export default __webpack_public_path__ + "static/media/macbook-2.cd9c4d0a.png";